import axios from "../config/axios-kb"


export const EntityRelationshipRepository = {
  delete: (id) => {
    return axios.delete(`/api/entity-relationship/${id}`);
  },
}